// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2sIU8","box":"_2Z116"};